A webhook subscription in a paginated list.
